import { useI18n } from "../i18n";
import type { Lang } from "../i18n/dictionaries";
import { cn } from "../lib/utils";

/* Bandeiras BR · US · MX — troca de idioma com um clique. */

const FLAGS: { lang: Lang; label: string }[] = [
  { lang: "pt", label: "Português (Brasil)" },
  { lang: "en", label: "English (US)" },
  { lang: "es", label: "Español (México)" },
];

function FlagSvg({ lang }: { lang: Lang }) {
  if (lang === "pt")
    return (
      <svg viewBox="0 0 28 20" className="h-5 w-7" aria-hidden>
        <rect width="28" height="20" fill="#009B3A" />
        <polygon points="14,2.6 25.4,10 14,17.4 2.6,10" fill="#FEDF00" />
        <circle cx="14" cy="10" r="4.6" fill="#002776" />
      </svg>
    );
  if (lang === "es")
    return (
      <svg viewBox="0 0 28 20" className="h-5 w-7" aria-hidden>
        <rect width="28" height="20" fill="#fff" />
        <rect width="9.34" height="20" fill="#006847" />
        <rect width="9.34" height="20" x="18.66" fill="#CE1126" />
        <circle cx="14" cy="10" r="2.1" fill="#8a5a2b" />
      </svg>
    );
  return (
    <svg viewBox="0 0 28 20" className="h-5 w-7" aria-hidden>
      <rect width="28" height="20" fill="#fff" />
      <g fill="#B22234">
        <rect width="28" height="2.857" />
        <rect width="28" height="2.857" y="5.714" />
        <rect width="28" height="2.857" y="11.428" />
        <rect width="28" height="2.857" y="17.143" />
      </g>
      <rect width="12" height="11.428" fill="#3C3B6E" />
      <g fill="#fff">
        <circle cx="2.5" cy="2.1" r=".7" />
        <circle cx="5.5" cy="2.1" r=".7" />
        <circle cx="8.5" cy="2.1" r=".7" />
        <circle cx="4" cy="4.5" r=".7" />
        <circle cx="7" cy="4.5" r=".7" />
        <circle cx="2.5" cy="6.9" r=".7" />
        <circle cx="5.5" cy="6.9" r=".7" />
        <circle cx="8.5" cy="6.9" r=".7" />
        <circle cx="4" cy="9.3" r=".7" />
        <circle cx="7" cy="9.3" r=".7" />
      </g>
    </svg>
  );
}

export function LangFlags({ className }: { className?: string }) {
  const { lang, setLang } = useI18n();
  return (
    <div
      className={cn(
        "flex items-center gap-1 rounded-full border border-line bg-surface p-1",
        className,
      )}
      role="group"
      aria-label="Idioma / Language / Idioma"
    >
      {FLAGS.map(({ lang: l, label }) => (
        <button
          key={l}
          type="button"
          onClick={() => setLang(l)}
          aria-pressed={lang === l}
          aria-label={label}
          title={label}
          className={cn(
            "overflow-hidden rounded-full transition-all duration-200 outline-none",
            "focus-visible:ring-2 focus-visible:ring-accent/60",
            lang === l
              ? "ring-2 ring-accent/60"
              : "opacity-40 saturate-50 hover:opacity-80 hover:saturate-100",
          )}
        >
          <FlagSvg lang={l} />
        </button>
      ))}
    </div>
  );
}
